import { ManualVerificationTable } from '../components/ManualVerificationTable';

/**
 * Manual Verification queue page. Lists interior scans held in the
 * `generated` / `published` review statuses and routes into the
 * per-scan review editor (`/interior/manual-verification/:jobId`).
 */
export function ManualVerificationPage() {
  return (
    <div className="space-y-6">
      <ManualVerificationTable />
    </div>
  );
}
